const CASH_FINANCIAL_PRODUCT_ID = 'CASH';

// Cash-equivalent securities are not cash here: the backend validates and
// persists them like any other held security, so they must stay in the matrix.
export const isCashHolding = (
  financialProductId: string,
  holding: { financialProduct?: { isCash?: boolean } },
) =>
  financialProductId === CASH_FINANCIAL_PRODUCT_ID ||
  holding.financialProduct?.isCash === true;
